import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-scroller',
  templateUrl: './scroller.component.html',
  styleUrls: ['./scroller.component.scss']
})
export class ScrollerComponent implements AfterViewInit, OnDestroy {

  @Output() endReached = new EventEmitter();
  @Input() windowScroll: boolean;
  @Input() scrollClass: string;
  @Input() scrollOffset = 1000;
  @Input() scrollMaxHeightPx: number;

  @ViewChild("wrapper", {static: true}) private wrapperElement: ElementRef<HTMLDivElement>;

  ngAfterViewInit(): void {
    if (this.windowScroll) {
      window.addEventListener('scroll', this.onScrollWindow);
    } else {
      this.wrapper.addEventListener('scroll', this.onScroll);
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.onScrollWindow);
    this.wrapper.removeEventListener('scroll', this.onScroll);
  }

  private get wrapper() {
    return this.wrapperElement.nativeElement;
  }

  get wrapperClasses() {
    return this.windowScroll ? this.scrollClass : this.scrollClass || 'mh-100 overflow-auto';
  }

  private onScrollWindow = () => {
    if (window.innerHeight + window.scrollY + this.scrollOffset > (this.wrapper.offsetTop + this.wrapper.offsetHeight)) {
      this.endReached.emit();
    }
  };

  private onScroll = (event: Event) => {
    const target = event.target as HTMLDivElement;
    if (target.scrollHeight - target.scrollTop - target.clientHeight < this.scrollOffset) {
      this.endReached.emit();
    }
  }
}
